import { ref as o, computed as e } from "vue";
import s from "jw-paginate";
function P({ totalItems: n, currentPage: r = 1, pageSize: u = 10, maxPages: g = 1 }) {
  const t = o(r), a = e(() => s(n, t.value, u, g));
  return {
    totalPages: e(() => a.value.totalPages),
    pages: e(() => a.value.pages),
    selectedPage: e(() => a.value.currentPage),
    endPage: e(() => a.value.endPage),
    startPage: e(() => a.value.startPage),
    maxVisiblePages: g,
    next: () => t.value += 1,
    prev: () => t.value -= 1,
    setPage: (l) => t.value = l
  };
}
export {
  P as usePagination
};
